// ONB-PARENT step 4: invite a co-parent (mock rev3 step 4, R-0137: e-mail only).
//   isDone  = a valid e-mail that is not the parent's own.
//   commit  = the app's household invite send (_sendHouseholdInvite, the SAME routine as the Add-a-Co-Parent modal: invite row, e-mail, cleanup of a failed send). On failure the step stays and the retry reuses a kept row.
//   After a successful send the step is LOCKED ("Invitation sent to ..."): going Back to it never sends a second invitation.
//   Skip    = nothing is written. Not offered to a parent who joined through a household invite (their family exists) or who already has a co-parent.
const H = () => window.HUD;
const T = (k, v) => H().T(k, v);
const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

export function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim()); }
export function isOwn(v, session) { return String(v || '').trim().toLowerCase() === String((session && session.email) || '').trim().toLowerCase() && !!(session && session.email); }
export function applicable(ctx) {
  const s = ctx && ctx.session; if (!s || s.role !== 'parent') return false;
  if (s.isPrimary === false) return false;                                   // joined through a household invite: the household already exists
  if (!s.householdId) return false;                                          // the invite row needs the household
  return !((ctx.DB && ctx.DB.coParents) || []).length;                       // already has a co-parent
}

export const coparentStep = {
  id: 'coparent', order: 50,
  applicable,
  label: () => T('onb_label_coparent'),
  summary: (r) => (r === 'done' ? T('onb_sum_coparent_done') : T('onb_sum_skipped', { label: T('onb_label_coparent') })),
  mount(api) {
    const h = H();
    const root = el('div');
    const ic = el('div', 'onb-icon', '👨‍👩‍👧'); ic.setAttribute('aria-hidden', 'true');
    const title = el('h2'), sub = el('p', 'onb-sub');
    const f = el('div', 'onb-field'), lab = el('label'), inp = el('input');
    inp.type = 'email'; inp.id = 'onb-coparent-email'; inp.autocomplete = 'off'; inp.inputMode = 'email'; inp.maxLength = 120; lab.htmlFor = 'onb-coparent-email';
    const hint = el('p', 'onb-hint-err'); hint.setAttribute('data-email-error', '1'); hint.setAttribute('role', 'alert');
    f.append(lab, inp, hint);
    const note = el('p', 'onb-note');
    const err = el('p', 'onb-error'); err.setAttribute('role', 'alert');
    root.append(ic, title, sub, f, note, err);
    let sentTo = null, kept = null;
    const val = () => inp.value.trim().toLowerCase();
    function hintText() { if (!inp.value.trim()) return ''; if (isOwn(inp.value, h.session)) return T('onb_coparent_own_email'); return emailOk(inp.value) ? '' : T('coparent_email_required'); }
    function texts() {
      title.textContent = T('onb_coparent_title'); sub.textContent = T('onb_coparent_sub'); lab.textContent = T('coparent_email_label'); inp.placeholder = T('coparent_email_placeholder');
      note.textContent = sentTo ? T('onb_coparent_sent', { email: sentTo }) : T('onb_coparent_note'); hint.textContent = hintText();
    }
    texts();
    inp.addEventListener('input', () => { hint.textContent = hintText(); api.refresh(); });
    return {
      el: root,
      isDone: () => !!sentTo || (emailOk(inp.value) && !isOwn(inp.value, h.session)),
      async commit() {
        if (sentTo) return { ok: true };                                       // never a second invitation
        const sess = h.session; if (!sess || !sess.id || !sess.householdId) return { ok: false, error: T('onb_error_generic') };
        const email = val();
        const res = await h._sendHouseholdInvite({ email, name: null, role: null, kept });
        kept = res.kept || null;
        if (!res.ok) return { ok: false, error: T('coparent_fail') };
        sentTo = email; inp.disabled = true; try { h.LS.set('householdInviteSent', true); } catch (_) {}
        note.textContent = T('onb_coparent_sent', { email }); hint.textContent = '';
        return { ok: true };
      },
      onEnter() { if (!sentTo && !inp.value) setTimeout(() => { try { inp.focus({ preventScroll: true }); } catch (_) {} }, 0); },
      relang: texts,
    };
  },
};
